import { Component, OnInit, ViewChildren, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Input } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Renderer } from '@angular/core';

@Component({
  selector: 'app-addaccomtype',
  templateUrl: './addaccomtype.component.html',
  styleUrls: ['./addaccomtype.component.css']
})
export class AddaccomtypeComponent implements OnInit, AfterViewInit {
  @ViewChildren('input') firstipcontrol;

  formname: String = "AccomType";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  focus: boolean = false;
  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  accomtypeColl: any = [];
  accomtypeBO: any = {};

  accomtypeid: number = 0

  accomtypeform = new FormGroup({
    accomtypeid: new FormControl(0),
    accomtypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });



  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.accomtypeid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.accomtypeform.reset();
      this.fnInitializeFormGroup();

      if (this.accomtypeid > 0) {
        this.fngetAccomType();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.accomtypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }


  fnInitializeFormGroup() {
    this.accomtypeform.setValue({
      accomtypeid: 0,
      accomtypename: '',
      inactive: false
    })
  }

  //Get 
  fngetAccomType() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'accomtypeid': this.accomtypeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAccomType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.accomtypeColl = res.json().result;
            var editdata = this.accomtypeColl[0];
            this.accomtypeBO = editdata;
            console.log(this.accomtypeBO)
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.accomtypeform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'accomtypeid': this.accomtypeid,
          'accomtypename': this.accomtypeform.get('accomtypename').value,
          'inactive': this.accomtypeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckAccomType(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.accomtypeform.get('accomtypeid').value > 0) {
                  //Update 
                  this.fnSetAccomType(data);
                }
                else {
                  //Insert 
                  this.fnInsertAccomType(data);
                }
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;
                  this.accomtypeform.controls['accomtypename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAccomType(data) {

    this.appService.fnInsertAccomType(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new accomtype has been added successfully.Insert Successfully");

            this.fnInsertActivityLog('INSERT', 0, data.accomtypename);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAccomType(data) {

    this.appService.fnSetAccomType(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The accomtype has been updated successfully.");

            this.fnInsertActivityLog('EDIT', this.accomtypeid, data.accomtypename);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/AccomType']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.accomtypeform.setValue({
      accomtypeid: deptBO.accomtypeid,
      accomtypename: deptBO.accomtypename,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }



      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
